<ng-template #shareLinksRef>
  <div class="shareLinks">
    <a class="link linkedin" target="_blank" [href]="shareLinkedinUrl()">
      <fa-icon [icon]="faLinkedinIn"></fa-icon>
    </a>
    <a class="link mail" (click)="toClipBoard()">
      <fa-icon [icon]="faLink"></fa-icon>
    </a>
  </div>
</ng-template>

<placeme-layout-seo [seo]="blog?.seo" [category]="blog?.__typename">
  <section class="main-content">
    <header>
      <h1 class="display">{{ blog?.seo?.title | translate }}</h1>
      <p>{{ blog?.seo?.description | translate }}</p>
    </header>
    <article class="blog">
      <ng-container *ngTemplateOutlet="shareLinksRef"></ng-container>
      <div class="container">
        <ng-container *ngTemplateOutlet="shareLinksRef"></ng-container>
        <div class="blog__author">
          <div class="container">
            <p class="blog__author__name">{{ blog?.team | displayTeamMember }}</p>
            <p class="blog__author__profile">{{ blog?.team?.displayProfile?.family?.name | translate }}</p>
          </div>
          <div class="blog__author__avatar">
            <img
              *ngIf="blog?.team"
              [src]="blog?.team | avatarUrl"
              [alt]="blog?.team | displayTeamMember"
              [title]="blog?.team | displayTeamMember"
            />
          </div>
        </div>
        <div class="blog__jumbotron">
          <img
            *ngIf="blog?.seo"
            [src]="
              blog?.seo
                | seoImageUrl
                  : {
                      text: false,
                      format: 'rectangle',
                      logo: true,
                      category: blog?.__typename
                    }
            "
            [alt]="blog?.seo?.title"
            [title]="blog?.seo?.title"
          />
        </div>
        <p class="blog__date">{{ blog?.publication | date }}</p>
      </div>
      <div class="blog__content">
        <markdown [data]="blog?.content"></markdown>
      </div>
    </article>
  </section>
</placeme-layout-seo>
